var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import styles from '@cof/fs-divider-core/lib/divider.lit.min.js';
import { css, html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
/**
 * The web component implementation of the Financial Services divider component
 *
 * ## Installation
 *
 * ```bash
 * npm i @cof/fs-divider-wc
 * ```
 *
 * ## Usage
 *
 * To import the side-effectful registration of `<fs-divider>` call
 *
 * ```javascript
 * import '@cof/fs-divider-wc/fs-divider.js';
 * ```
 *
 * To import the `FsDivider` class as either a base class or to self-register the custom element use
 *
 * ```javascript
 * import { FsDivider } from '@cof/fs-divider-wc';
 * ```
 *
 * ## Example
 *
 * ```html
 * <fs-divider emphasis="medium" inverted></fs-divider>
 * ```
 *
 * @element fs-divider
 */
export class FsDivider extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * What amount of emphasis should the divider reveal? Possible values
         * are 'high', 'medium' and 'low'. Defaults to 'high'.
         */
        this.emphasis = 'high';
        /**
         * If true the divider will use an inverted color theme.
         */
        this.inverted = false;
    }
    static get styles() {
        return [
            css `
      :host {
        display: flex;
      }
      hr {
        flex: 1 1 auto;
      }
    `,
            styles
        ];
    }
    render() {
        return html `<hr class="fs-divider fs-divider--${this.emphasis}-emphasis ${this.inverted ? 'fs-divider--inverted' : ''}"/>`;
    }
}
/** The element's canonical name for use with safe define */
FsDivider.canonicalName = 'divider';
__decorate([
    property({ type: String, reflect: true })
], FsDivider.prototype, "emphasis", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], FsDivider.prototype, "inverted", void 0);
//# sourceMappingURL=Divider.js.map